import { proposalrequest } from '@mep/pae-commons';
import { Checkbox, Form, Input } from 'antd';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { memo, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import CardTypeSelect from '@/components/CardTypeSelect';
import InfoBox from '@/components/InfoBox';
import UploadFileDragger from '@/components/UploadFileDragger';
import { validations } from '@/utils/fields';

const { CNA_SECTOR, TCP, OTHER } = proposalrequest;

const ProposalIsReconversion = ({
  value,
  onChange,
  translate,
  proposal = {},
  setProposal,
}) => {
  const { t } = useTranslation(translate || 'common');
  
  const options = useMemo(() => [TCP, CNA_SECTOR, OTHER].map((e) => ({
    label: t(`proposalRequest.sectors.${e}`),
    value: e,
  })), [t]);
  
  const onActiveChange = useCallback((e) => {
    if (e?.target?.checked) {
      proposal.ownerSector = TCP;
      proposal.lastWorkNIT = null;
      proposal.onatPictures = [];
      proposal.isReconversion = e?.target?.checked;
      setProposal(proposal);
    }
    onChange && onChange(e?.target?.checked);
  }, [onChange, proposal, setProposal]);
  
  return (<>
    <Checkbox
      checked={value}
      className={classNames('mx-0 my-px mb-2')}
      size={'large'}
      onChange={onActiveChange}
    >
      {t('proposalRequest.form.general.origen.isReconversion')}
    </Checkbox>
    {!!value && <InfoBox title={t('proposalRequest.form.general.origen.help')}/>}
    {!!value &&
    <>
      <Form.Item
        name={'ownerSector'}
        label={t('proposalRequest.form.general.origen.label')}
        initialValue={TCP}
        className={'mt-2'}
        required={value}
        rules={[{ required: value }]}>
        <CardTypeSelect
          options={options}
          translate={translate}
          isButton={false}
          fullWidth={false}
          isRow={true}
          isCheckBox={false}
          initialValue={TCP}
        />
      </Form.Item>
      <Form.Item name={'lastWorkNIT'} label={t('proposalRequest.form.general.lastWorkNIT.label')}
        rules={[{ required: value }, validations.nitLength(), validations.nitNumber()]}>
        <Input size={'large'} placeholder={t('numberPlaceHolder')} className="md:w-1/2"/>
      </Form.Item>
      <Form.Item
        name={'onatPictures'}
        label={t('proposalRequest.form.general.onatPictures.label')}
        rules={[validations.min2Pictures()]}
        extra={<InfoBox title={t('proposalRequest.form.general.onatPictures.help')}/>}
        initialValue={[]}>
        <UploadFileDragger
          aspect={16 / 9}
          cropImage
          multiple
          isImage
          translation={'admin'}
          descriptionText={'upload'}/>
      </Form.Item>
    </>}
  </>);
};

ProposalIsReconversion.propTypes = {
  value: PropTypes.object,
  translate: PropTypes.string,
  onChange: PropTypes.func,
  proposal: PropTypes.object,
  setProposal: PropTypes.func,
};

ProposalIsReconversion.defaultProps = {};

export default memo(ProposalIsReconversion);
